import React, { useState, useEffect } from "react";

const Loader = ({ className, isPrimaryColor = false, backgroundOpacity = "0.5", isButton = false }) => {

  const primaryColor = "#848aff";
  const white = "#ffffff";

  const color = isPrimaryColor ? primaryColor : white;

  return (
    <>
      <style jsx>{`
        @keyframes slowSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .slow-spin {
          animation: slowSpin 3s linear infinite;
        }
      `}</style>

        <div className={`relative ${className}`}>
          {/* Spinning Gear */}
          <svg 
            viewBox="0 0 1285 1285" 
            xmlns="http://www.w3.org/2000/svg" 
            className="slow-spin"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1243.65 519.441L1169.05 506.631C1156.19 456.551 1136.36 409.291 1110.67 365.881L1154.41 304.001C1167.38 285.651 1170.3 262.091 1154.41 246.201C1115.83 207.601 1077.23 169.011 1038.63 130.421C1022.74 114.531 999.175 117.441 980.835 130.421L918.955 174.161C875.555 148.481 828.265 128.671 778.195 115.801L765.395 41.1913C761.605 19.0313 746.995 0.321289 724.525 0.321289C669.945 0.321289 615.375 0.321289 560.795 0.321289C538.315 0.321289 523.725 19.0313 519.915 41.2013L507.115 115.811C457.035 128.671 409.765 148.501 366.355 174.181L304.485 130.431C286.135 117.451 262.575 114.541 246.685 130.431C208.095 169.031 169.505 207.611 130.905 246.211C115.015 262.101 117.935 285.661 130.905 304.011L174.645 365.871C148.965 409.281 129.145 456.561 116.285 506.641L41.6849 519.451C19.5149 523.251 0.784912 537.851 0.784912 560.321C0.784912 614.901 0.784912 669.481 0.784912 724.051C0.784912 746.521 19.5149 761.131 41.6649 764.931L116.265 777.731C129.125 827.811 148.955 875.081 174.635 918.491L130.895 980.371C117.925 998.721 115.005 1022.28 130.895 1038.17C169.485 1076.77 208.075 1115.36 246.675 1153.95C262.565 1169.83 286.135 1166.92 304.485 1153.95L366.355 1110.21C409.755 1135.89 457.045 1155.7 507.115 1168.57L519.915 1243.18C523.715 1265.33 538.315 1284.06 560.795 1284.06C615.375 1284.06 669.945 1284.06 724.515 1284.06C746.995 1284.06 761.595 1265.34 765.395 1243.18L778.195 1168.57C828.285 1155.72 875.555 1135.88 918.965 1110.19L980.835 1153.93C999.185 1166.91 1022.74 1169.82 1038.63 1153.93C1077.23 1115.33 1115.82 1076.75 1154.41 1038.15C1170.29 1022.26 1167.39 998.701 1154.41 980.351L1110.66 918.481C1136.35 875.081 1156.17 827.801 1169.03 777.731L1243.65 764.921C1265.8 761.121 1284.52 746.521 1284.52 724.051C1284.52 669.471 1284.52 614.891 1284.52 560.321C1284.52 537.851 1265.8 523.241 1243.65 519.441ZM642.655 1081.66C885.365 1081.66 1082.12 884.901 1082.12 642.191C1082.12 399.481 885.365 202.721 642.655 202.721C399.945 202.721 203.185 399.481 203.185 642.191C203.185 884.901 399.945 1081.66 642.655 1081.66Z"
              fill={color}
              fillOpacity={backgroundOpacity}
            />
          </svg>

          {/* Static Heart in the Center */}
          <svg 
            viewBox="0 0 1284 1284" 
            xmlns="http://www.w3.org/2000/svg" 
            className="absolute inset-0 m-auto animate-gen-pulse-zero"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M642 526.18L689.09 479.09C747.31 420.87 842.47 420.87 900.7 479.09C958.92 537.31 958.92 632.47 900.7 690.7L642 949.4L383.31 690.7C325.09 632.48 325.09 537.32 383.31 479.09C441.53 420.87 536.69 420.87 594.92 479.09L642 526.18Z"
              fill={ isButton ? white : primaryColor } 
            />
          </svg>
        </div>

    </>
  );
};

export default Loader;
